module.exports = __webpack_public_path__ + "static/img/quick_link07.b7448826.png";